<template>
    <div class="px-30 lg:j-p-0 lg:j-w-1180 mx-auto pt-120 lg:j-pt-160">
        <h2 class="earn-title">{{ t('member_index.earn_points.title') }}</h2>
        <ul class="grid grid-cols-1 lg:grid-cols-3 gap-20 lg:j-gap-20">
            <li v-for="{ type, icon, title, desc, link, } in list" class="earn-item">
                <div>
                    <div class="earn-icon">
                        <img :src="icon">
                    </div>
                    <h3 class="earn-item-title">{{ title }}</h3>
                    <p class="earn-text" v-html="desc"></p>
                </div>
                <div v-if="!props.isLogin" class="w-full flex items-center justify-between">
                    <span
                        class="Poppins-Bold font-bold text-primary lg:(j-text-16 j-leading-26 j-mr-30) hover:text-primary cursor-pointer"
                        @click.prevent="acrossDomainJump(title)"
                    >{{ t('member_index.common.quick_login')}} &gt;</span>
                </div>
                <div v-else>
                    <template v-if="['Register', 'Email', 'Sms', 'Birthday'].includes(type)">
                        <div v-if="isUsed[type]" class="flex-start text-primary Poppins-SemiBold font-semibold leading-80 lg:j-leading-40">
                            <span class="flex-center w-36 h-36 text-22 lg:(j-w-24 j-h-24 j-text-16) rounded-full bg-#FFF1EB Poppins-Bold font-bold"><CheckOutlined /></span>
                            <span class="text-28 ml-22 lg:(j-text-18 j-ml-8)">{{ t('member_index.earn_points.points_earned') }}</span>
                        </div>
                        <button v-else class="go-now-btn" @click.prevent="goNow(type, link, title)">{{ t('member_index.earn_points.go_now') }}</button>
                    </template>
                    <button v-else class="go-now-btn" @click.prevent="goNow(type, link, title)">{{ t('member_index.earn_points.go_now') }}</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { CheckOutlined, } from '@ant-design/icons-vue';
    import { getAssetsFile, cookie, COLLECTION_LINK, uLogin, } from '@u/common'
    import { getRulePointAndIssueStatus, getCustomerRulePointAndIssueStatus, } from '@a/index'
    import { shopifyLogin, shopLists } from "@a/userCommon";
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useRoute } from 'vue-router'
    import { useStore } from 'vuex';

    const { t } = useI18n();
    const store = useStore();

    const userInfo = computed(() => store.getters.userInfo);
    const language = computed(() => store.getters.language.current);

    const props = defineProps({
        isLogin: Boolean
    })

    const list = reactive([
        {
            type: 'Register',
            icon: getAssetsFile('index', 'PC-Membership_Registration.svg'),
            title: t('member_index.earn_points.membership_registration'),
            desc: '',
            link: '',
        },
        {
            type: 'Email',
            icon: getAssetsFile('index', 'PC-EDM_Subscribtion.svg'),
            title: t('member_index.earn_points.email_subscribtion'),
            desc: '',
            link: '/account/myProfile',
        },
        {
            type: 'Sms',
            icon: getAssetsFile('index', 'PC-SMS_Subscribtion.svg'),
            title: t('member_index.earn_points.sms_subscribtion'),
            desc: '',
            link: '/account/myProfile',
        },
        {
            type: 'Birthday',
            icon: getAssetsFile('index', 'PC-Fullfill_Your_Birthday.svg'),
            title: t('member_index.earn_points.fill_in_your_birthday'),
            desc: '',
            link: '/account/myProfile',
        },
        {
            type: 'Warranty',
            icon: getAssetsFile('index', 'PC-Extend_Your_Warranty.svg'),
            title: t('member_index.earn_points.extend_your_warranty'),
            desc: '',
            link: 'https://support.jackery.com/extend-warranty',
        },
        {
            type: 'ShopEarn',
            icon: getAssetsFile('index', 'PC-Shop_and_Earn.svg'),
            title: t('member_index.earn_points.shop_and_earn'),
            desc: '',
            link: COLLECTION_LINK[language.value.cr],
        },
    ])

    const isUsed = reactive({
        Register: false,
        Email: false,
        Sms: false,
        Birthday: false,
    })

    const getEarnPoints = async (METHOD, params) => {
        const {
            registerPoint, // 注册积分
            emailPoint, // 邮件积分
            smsPoint, // 短信积分
            birthdayEveryYearPoint, // 每年生日积分
            fillBirthdayPoint, // 完善生日积分
            warrantyPoint, // 延保积分
            orderCountPoint, // 累计订单数积分
            orderCount, // 累计订单数梯度
            orderAmountPoint, // 累计订单金额积分
            orderAmount, // 累计订单金额梯度

            issuedRegister,
            issuedEmail, 
            issuedSms,
            issuedFillBirthday,
        } = await METHOD(params)
        list[0].desc = t('member_index.earn_points.membership_registration_desc', [registerPoint]) // Register
        list[1].desc = issuedEmail ? t('member_index.earn_points.email_subscribtion_desc', [emailPoint]) : `${t('member_index.earn_points.email_subscribtion_desc', [emailPoint])} <br/> ${t('member_index.earn_points.tip')}` // Email
        list[2].desc = issuedSms ?  t('member_index.earn_points.sms_subscribtion_desc', [smsPoint]) : `${t('member_index.earn_points.sms_subscribtion_desc', [smsPoint]) } <br/> ${t('member_index.earn_points.tip')}`// Sms
        list[3].desc = t('member_index.earn_points.fill_in_your_birthday_desc', [fillBirthdayPoint, birthdayEveryYearPoint]) // Birthday
        list[4].desc = t('member_index.earn_points.extend_your_warranty_desc', [warrantyPoint]) // Warranty
        list[5].desc = t('member_index.earn_points.shop_and_earn_desc', [orderCountPoint, orderCount, orderAmountPoint, orderAmount]) // ShopEarn

        isUsed.Register = issuedRegister
        isUsed.Email = issuedEmail
        isUsed.Sms = issuedSms
        isUsed.Birthday = issuedFillBirthday
    }

    onMounted(async () => {
        const METHOD = !props.isLogin ? getRulePointAndIssueStatus : getCustomerRulePointAndIssueStatus

        const params = {
            shopId: language.value.shop_id,
            uid: props.isLogin ? userInfo.value.uid : null,
        }
        getEarnPoints(METHOD, params)
    })

    // 跨域名 跳转
    const acrossDomainJump = (name) => {
        const params = {
            jackery_id: userInfo.value.userName || "",
            position: t('member_index.earn_points.title'),
            title: name,
            button_name: t('member_index.common.quick_login')
        }
        gaPushDataLayer( params)
        if(window.jackeryLoginApp) {
            window.jackeryLoginApp.modalLogin({
                return_url: `${window.location.origin}${window.location.pathname}`, 
                register_act: 'MEM-Register'
            }) 
        }
        return
    }

    // go now
    const goNow = (type, link, title) => {
        const params = {
        jackery_id: userInfo.value.userName || "",
        position:  t('member_index.earn_points.title'),
        title: title,
        button_name: `${t('member_index.earn_points.go_now') }`
        }
        gaPushDataLayer( params)

        if (type === 'Register') {
            window.location.href = `${import.meta.env.VITE_ID_URL}/register?redirect=/index`
        }
        else if (['Email', 'Sms', 'Birthday', 'Warranty'].includes(type)) {
            // 是否为 iOS 移动终端
            const isiOS = () => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            // 因为苹果的安全机制拦截了，所以不能打开新的标签页
            isiOS() ? (window.location.href = link) : window.open(link)
        }
        else {
            uLogin(shopifyLogin, language.value.shop_id, `${language.value.domain}${link}`, true);
        }
    }
</script>

<style scoped>
    .earn-title {
    @apply
        w-full text-left lg:text-center text-52 leading-64 lg:j-text-48
        lg:j-leading-48 Poppins-Semibold font-semibold text-sub p-40 lg:j-p-0 lg:j-mb-40
    }
    .earn-item {
    @apply
        w-full h-auto rounded-16 lg:j-w-380 lg:j-rounded-16 bg-white
        p-40 lg:j-px-30 lg:j-pt-35 lg:j-pb-24 lg:flex lg:items-start lg:justify-between lg:flex-col
    }
    .earn-icon {
    @apply
        w-120 h-120 lg:j-w-72 lg:j-h-72 bg-white rounded-8 lg:j-rounded-8 overflow-hidden
    }
    .earn-item-title {
    @apply
        text-40 leading-65 lg:j-text-24 lg:j-leading-24 Poppins-Semibold font-semibold text-black mt-60 mb-25 lg:j-mt-30 lg:j-mb-15
    }
    .earn-text {
    @apply
        mb-65 lg:j-mb-40 text-24 leading-40 lg:j-text-14 lg:j-leading-22 Poppins-Medium font-medium text-black/60
    }
    .go-now-btn {
    @apply
        flex-center h-80 text-32 px-50 rounded-full bg-#FFF8F5 text-primary Poppins-Semibold font-semibold cursor-pointer
        lg:(j-h-40 j-text-16 j-px-15 j-rounded-8 bg-#FFF1EB) hover:(text-white bg-primary) transition-all duration-300
    }
</style>
